import { registerRoute } from '@lessonup/typescript-core/services';
import { ActionButton, Modal } from '@lessonup/typescript-core/ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import LoginSelectApplication from '../../pages/login/loginSteps/LoginSelectApplication';
import { loggedInUser } from '../../redux/selectors';
import { AppUserService } from '../../services/AppServices';
import { LoginButtons } from './LoginButtons';
import './LoginModal.less';
import PasswordLogin from './PasswordLogin';

export interface LoginModalConfig {
  userService: AppUserService;
  initialPage?: Page;
}
export type LoginModalProps = LoginModalConfig & {
  closeModal: (res: LoginModalResult | undefined) => void;
};

export interface LoginModalResult {
  status: 'success' | 'failed';
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type -- auto-generated TECH-258
  data?: {};
}

export interface ViewModel {
  iframeReady: boolean;
  userService: AppUserService;
}

export type Page = 'start' | 'login' | 'confirm';

function LoginModal(props: LoginModalProps) {
  const user = useSelector(loggedInUser());
  const [page, setPage] = useState<Page>(props.initialPage || 'start');
  const { t } = useTranslation('login');

  const handleModalClose = (status: LoginModalResult['status']) => {
    props.closeModal(status ? { status } : undefined);
  };

  if (user) {
    handleModalClose('success');
  }

  const handleForgotPassword = () => {
    props.closeModal(undefined);
  };

  function renderSSO() {
    return (
      <div className="login__page-option">
        <h3>{t('ssoHeader')}</h3>
        <LoginButtons source="modal" />
      </div>
    );
  }

  return (
    <React.Fragment>
      <Modal
        title={t('title')}
        isOpen={true}
        onRequestClose={() => handleModalClose('failed')}
        animationOnOpen="slide-from-bottom"
        className="login-modal"
        width="large"
      >
        <div className="login__content">
          <div className="login__page login__page-options show">
            {page === 'start' && <LoginSelectApplication next={() => setPage('login')} />}
            {page === 'login' && (
              <>
                <PasswordLogin
                  loginWithPassword={props.userService.loginWithPassword}
                  handleForgotPassword={handleForgotPassword}
                  source="modal"
                />
                <div className="login__page-divider" />
                {renderSSO()}
              </>
            )}
            {page === 'confirm' && (
              <div className="login__page-option">
                <h3>{t('email-sent-title')}</h3>
                <p>{t('email-sent-description')}</p>
                <ActionButton theme="light" onClick={() => setPage('login')}>
                  {t('backToLogin')}
                </ActionButton>
              </div>
            )}
          </div>
          {page !== 'confirm' && (
            <Link onClick={() => handleModalClose('failed')} to={registerRoute()} className="back-link">
              {t('register')}
            </Link>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default LoginModal;
